import { getUserDetails, isSuperAdminUser } from "../../../services/authService";
import { getUserInfo } from "../../../services/localStorage";
import { canShowAdminPriceTrace } from "../../../features/admin-price-trace/adminPriceTraceFlags";

function resolveSessionUserObject() {
  const fromDetails = getUserDetails();
  if (fromDetails && typeof fromDetails === "object") return fromDetails;
  const fromStorage = getUserInfo();
  if (fromStorage && typeof fromStorage === "object") return fromStorage;
  return null;
}

function normalizeRole(value) {
  return String(value || "").trim().toLowerCase().replace(/\s+/g, "_");
}

function readSuperAdminFromUser(user) {
  if (!user || typeof user !== "object") return false;
  const role = normalizeRole(user.role ?? user.agentRole);
  if (role === "super_admin") return true;
  const ut = normalizeRole(user.usertype ?? user.userType);
  return ut === "super_admin";
}

/**
 * Whether the current user is super_admin (role or usertype).
 */
export function userHasSuperAdminRole() {
  return readSuperAdminFromUser(resolveSessionUserObject());
}

/**
 * Organized-tour price TRACE in UI (card block, magnifier, profile sidebar).
 * Regular agents never see it — only admin / super_admin (email, role, usertype, is_admin)
 * or PRICE_TRACE_DEBUG. Optional: VITE_ORG_TOUR_PRICE_TRACE_UI=1 in DEV.
 */
export function shouldShowOrganizedTourPriceTraceUi() {
  if (userHasSuperAdminRole()) return true;
  if (typeof isSuperAdminUser === "function" && isSuperAdminUser()) return true;
  if (canShowAdminPriceTrace()) return true;
  const forced =
    import.meta.env?.DEV &&
    String(import.meta.env?.VITE_ORG_TOUR_PRICE_TRACE_UI || "").trim() === "1";
  return forced;
}
